import { DataSourceOrganization } from './data-sources';
import { Study } from './studies';

export enum UserGroup {
  SUPER_ADMIN = 'SuperAdmins',
  RESEARCHER = 'Researchers',
  PARTICIPANT = 'Participants',
  ADMIN = 'Admins',
}

export enum PreferredMfaSetting {
  SMS_MFA = 'SMS_MFA',
  EMAIL_OTP = 'EMAIL_OTP',
  SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
}

export const userGroupsList = Object.values(UserGroup);

export interface User {
  userId: string;
  email: string;
  givenName: string;
  familyName: string;
  phoneNumber: string;
  groups: UserGroup[];

  participantId?: string;
  researcherId?: string;

  createdAt?: string;
  updatedAt?: string;

  status?: string;
  enabled?: boolean;
  emailVerified?: boolean;
  phoneNumberVerified?: boolean;

  preferredMfaSetting?: PreferredMfaSetting;
  userMFASettingList?: string[];
}

export interface UserOverview {
  organizations: OrganizationOverview[];
  studies: Study[];
  dataSources: DataSourceOrganization[];
  organizationalUnits: OrganizationalUnitsOverview[];
}

export interface OrganizationOverview {
  organizationId: string;
  organizationName: string;
  organizationDisplayName: string;
  researchers: number;
  studies: number;
  organizationalUnits: number;
  dataSources: number;
}

export interface OrganizationalUnitsOverview {
  rootOrganizationId: string;
  organizationId: string;
  organizationName: string;
  organizationDisplayName: string;
  researchers: number;
  studies: number;
  dataSources: number;
}

export interface StudiesOverview {
  studyId: string;
  name: string;
  displayName: string;
  organizationName: string;
  participants: number;
  organizationId: string;
  rootOrganizationId: string;
  createdAt: string;
  updatedAt: string;
}
